import MultiStepFormLayout from '../Layout/FormLayout';
import {
  decrementStep,
  incrementStep,
  updateFormData,
} from '../features/FormRegistration';
import { useDispatch, useSelector } from 'react-redux';

import PrimaryButton from '../components/PrimaryButton';
import { getStateId, pushDataLayer, State } from '../utils/helpers';
import SelectableOptions from '../components/SelectableOptions';
import SecondaryButton from '../components/SecondaryButton';
import LeftChevron from '../icons/LeftChevron';

function Step1() {
  const handleSelectLocation = (location: string) => {
    const stateId = getStateId(location as State);
    dispatch(
      updateFormData({
        ...formData,
        location,
        state: stateId,
      }),
    );
  };
  const { isMobileView } = useSelector((state: any) => state.viewport);
  const dispatch = useDispatch();
  const { formData, states } = useSelector(
    (state: any) => state.formRegistration,
  );

  if (isMobileView) {
    return (
      <MultiStepFormLayout>
        <div className="flex flex-col items-center h-full justify-between">
          <h1 className="text-[22px] text-start font-bold">
            Which state do you live in?
          </h1>

          <SelectableOptions
            options={states.map((state: any) => state.state_name)}
            optionClassname="w-full"
            value={formData.location}
            onChange={(value) => {
              handleSelectLocation(value);
            }}
          />

          <div className="w-full justify-between h-full flex items-center gap-[10px] sticky bottom-0 bg-[white] p-4 z-10 border-t border-[#D1D7DF] mt-6">
            <SecondaryButton
              leftSection={<LeftChevron />}
              onClick={() => {
                dispatch(decrementStep());
              }}>
              Previous
            </SecondaryButton>
            <PrimaryButton
              text="Continue"
              onClick={() => {
                pushDataLayer('funnel_state', {
                  state: formData.location,
                });
                dispatch(incrementStep());
              }}
              classNames="w-[50%] md:w-auto"
              disabled={formData.location === '-'} // Disable button if no location is selected
            />
          </div>
        </div>
      </MultiStepFormLayout>
    );
  }
  return (
    <MultiStepFormLayout>
      <div className="flex flex-col items-center h-full justify-between">
        <h1 className="text-[22px] text-start font-bold self-start">
          Which state do you live in?
        </h1>

        <SelectableOptions
          options={states.map((state: any) => state.state_name)}
          optionClassname="w-full"
          value={formData.location}
          onChange={(value) => {
            handleSelectLocation(value);
          }}
        />

        <div className="w-full justify-between h-full flex items-center gap-[10px] sticky bottom-0 bg-[white] p-4 z-10 border-t border-[#D1D7DF] mt-6">
          <SecondaryButton
            leftSection={<LeftChevron />}
            onClick={() => {
              dispatch(decrementStep());
            }}>
            Previous
          </SecondaryButton>
          <PrimaryButton
            text="Continue"
            onClick={() => {
              pushDataLayer('funnel_state', {
                state: formData.location,
              });
              dispatch(incrementStep());
            }}
            classNames="w-[50%] md:w-auto"
            disabled={formData.location === '-'} // Disable button if no location is selected
          />
        </div>
      </div>
    </MultiStepFormLayout>
  );
}

export default Step1;
